// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  font-size: 2.2rem;
}

ion-button {
  --background-hover-opacity: 0;
}

.deposit-icon {
  height: 38px;
  width: 38px;
  cursor: pointer;
  background-color: var(--ion-color-primary);
  border-radius: 25px;
}

.deposit-strip {
  display: flex;
  margin-left: 40px;
  margin-top: 10px;
}
.deposit-strip .deposit-icon-container {
  z-index: 9999;
  height: 44px;
  width: 44px;
  border: 3px solid;
  border-color: var(--ion-color-light);
  border-radius: 25px;
  transform: translate(3px, 5px);
}
.deposit-strip .deposit-icon-container ion-icon {
  font-size: 2.5rem;
  transform: translate(-1px, -1px);
}
.deposit-strip .deposit-text-container {
  z-index: 9900;
}

.deposit-text-container {
  transform: translate(-40px, 5px);
  background-color: var(--ion-color-primary);
  border-radius: 25px;
  height: 44px;
  width: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.deposit-text-container p {
  font-family: var(--font-secondary) !important;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 13px;
  letter-spacing: 2px;
  color: var(--ion-color-light);
}

a {
  cursor: pointer;
  font-size: 11px;
  font-family: var(--font-primary);
  margin: 0 !important;
  padding: 0 !important;
  color: var(--ion-color-light);
}
@media (max-width: 355px) {
  a {
    font-size: 10px;
  }
}

.full-screen-click-filler {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/redeem-button/redeem-button.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAEI;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,8BAAA;AAAR;AAEQ;EACI,iBAAA;EACA,gCAAA;AAAZ;AAII;EACI,aAAA;AAFR;;AAMA;EACI,gCAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACI,6CAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;AAHR;;AAOA;EACI,eAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;AAJJ;AAMI;EARJ;IASQ,eAAA;EAHN;AACF;;AAMA;EACI,WAAA;EACA,YAAA;AAHJ","sourcesContent":["ion-icon {\r\n    font-size: 2.2rem;\r\n}\r\n\r\nion-button {\r\n    --background-hover-opacity: 0;\r\n}\r\n\r\n\r\n.deposit-icon {\r\n    height: 38px;\r\n    width: 38px;\r\n    cursor: pointer;\r\n    background-color: var(--ion-color-primary);\r\n    border-radius: 25px;\r\n}\r\n\r\n.deposit-strip {\r\n    display: flex;\r\n    margin-left: 40px;\r\n    margin-top: 10px;\r\n\r\n    .deposit-icon-container {\r\n        z-index: 9999;\r\n        height: 44px;\r\n        width: 44px;\r\n        border: 3px solid;\r\n        border-color: var(--ion-color-light);\r\n        border-radius: 25px;\r\n        transform: translate(3px, 5px);\r\n\r\n        ion-icon {\r\n            font-size: 2.5rem;\r\n            transform: translate(-1px, -1px);\r\n        }\r\n    }\r\n\r\n    .deposit-text-container {\r\n        z-index: 9900;\r\n    }\r\n}\r\n\r\n.deposit-text-container {\r\n    transform: translate(-40px, 5px);\r\n    background-color: var(--ion-color-primary);\r\n    border-radius: 25px;\r\n    height: 44px;\r\n    width: 240px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    p {\r\n        font-family: var(--font-secondary) !important;\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        font-size: 14px;\r\n        line-height: 13px;\r\n        letter-spacing: 2px;\r\n        color: var(--ion-color-light);\r\n    }\r\n}\r\n\r\na {\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    font-family: var(--font-primary);\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    color: var(--ion-color-light);\r\n\r\n    @media (max-width: 355px) {\r\n        font-size: 10px;\r\n    }\r\n}\r\n\r\n.full-screen-click-filler {\r\n    width: 100%;\r\n    height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
